module.exports = __webpack_public_path__ + "static/img/icon-company-active.4e6a728b.png";